import i18n from "../../i18n/index";
export default {
  props: {
    summaryData: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      headers: [
        { text: i18n.t('headers.provider'), value: "providerId", sortable: false },

        {
          text: i18n.t('headers.total-documents'),
          value: "totalDocuments",
          sortable: false
        },
        {
          text: i18n.t('headers.total-moderator-fee-with-weights'),
          value: "totalModeratorFee",
          sortable: false
        }
      ],
      summaryItems: []
    };
  },
  watch: {
    summaryData() {
      this.summaryItems = this.summaryData;
    }
  },
  methods: {

  }
};
